import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { CommitmentActionButtonProps } from '../commandActions/types'
import { CreatePolicyForm } from './CreatePolicyForm'

export function CreatePolicyCommand(props: CommitmentActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const actions = useHook('mutators.life.usePolicyActions')({
    tenantId,
    ownerId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="life.NewPolicyCommandData"
      title={translate('createPolicyModalButton.title')}
      commandDataForm={CreatePolicyForm}
      {...props}
      submit={submit}
    />
  )
}
